import { Component, computed, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppInfo } from '../../../../global/environment';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { TelephoneLinkComponent } from '../../../../shared/components/telephone-link/telephone-link.component';
import { OrbitFormClaimService } from '../../book-claim/services/orbit-form-claim.service';

@Component({
  selector: 'app-service-not-due',
  imports: [ButtonComponent, TelephoneLinkComponent],
  templateUrl: './service-not-due.component.html',
  styleUrl: './service-not-due.component.scss',
})
export class ServiceNotDueComponent implements OnInit {
  planNumber = signal<string | undefined>(undefined);

  protected viewModel = computed(() => {
    const { status } = this.orbitFormClaimService.state.formError?.error || {};

    return {
      repairsPageUrl: `${AppInfo.Environment.claimsURL}/my-plans/${this.planNumber()}/claims`,
      httpStatus: this.orbitFormClaimService.state.formError?.status,
      errorCode: status ?? 'NC003',
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly orbitFormClaimService: OrbitFormClaimService
  ) {}

  ngOnInit(): void {
    this.planNumber.set(this.route.snapshot.params['planNumber']);
  }
}
